// src/pages/GalleryPage.js
import React, { useState, useEffect } from 'react';
import { makeImageAsset } from '../utils/makeImageAsset';

import exterior4864 from '../assets/reading-towers/building/gallery/exterior-dsc4864-1400.jpg';
import exterior4864Full from '../assets/reading-towers/building/gallery/exterior-dsc4864-2800.jpg';
import exterior4870 from '../assets/reading-towers/building/gallery/exterior-dsc4870-1400.jpg';
import exterior4870Full from '../assets/reading-towers/building/gallery/exterior-dsc4870-2800.jpg';
import exterior4873 from '../assets/reading-towers/building/gallery/exterior-dsc4873-1400.jpg';
import exterior4873Full from '../assets/reading-towers/building/gallery/exterior-dsc4873-2800.jpg';
import exterior4876 from '../assets/reading-towers/building/gallery/exterior-dsc4876-1400.jpg';
import exterior4876Full from '../assets/reading-towers/building/gallery/exterior-dsc4876-2800.jpg';
import exterior4890 from '../assets/reading-towers/building/gallery/exterior-dsc4890-1400.jpg';
import exterior4890Full from '../assets/reading-towers/building/gallery/exterior-dsc4890-2800.jpg';
import foyer from '../assets/reading-towers/building/gallery/foyer-1400.jpg';
import foyerFull from '../assets/reading-towers/building/gallery/foyer-2800.jpg';
import hope from '../assets/reading-towers/building/gallery/hope-1400.jpg';
import hopeFull from '../assets/reading-towers/building/gallery/hope-2800.jpg';
import northView from '../assets/reading-towers/building/gallery/north-view-1400.jpg';
import northViewFull from '../assets/reading-towers/building/gallery/north-view-2048.jpg';
import southView from '../assets/reading-towers/building/gallery/south-view-1400.jpg';

import rt404Living from '../assets/reading-towers/generated/units/rt-404/rt-404-living-1024.jpg';
import rt404LivingFull from '../assets/reading-towers/generated/units/rt-404/rt-404-living-2048.jpg';
import rt404Kitchen from '../assets/reading-towers/generated/units/rt-404/rt-404-kitchen-1024.jpg';
import rt404KitchenFull from '../assets/reading-towers/generated/units/rt-404/rt-404-kitchen-2048.jpg';
import rt404Bedroom from '../assets/reading-towers/generated/units/rt-404/rt-404-bedroom-1024.jpg';
import rt404BedroomFull from '../assets/reading-towers/generated/units/rt-404/rt-404-bedroom-2048.jpg';
import rt404BedroomAlt from '../assets/reading-towers/generated/units/rt-404/rt-404-bedroom-alt-1024.jpg';
import rt404BedroomAltFull from '../assets/reading-towers/generated/units/rt-404/rt-404-bedroom-alt-2048.jpg';

import rt409Living from '../assets/reading-towers/generated/units/rt-409/rt-409-living-1024.jpg';
import rt409LivingFull from '../assets/reading-towers/generated/units/rt-409/rt-409-living-2048.jpg';
import rt409Kitchen from '../assets/reading-towers/generated/units/rt-409/rt-409-kitchen-1024.jpg';
import rt409KitchenFull from '../assets/reading-towers/generated/units/rt-409/rt-409-kitchen-2048.jpg';
import rt409Dining from '../assets/reading-towers/generated/units/rt-409/rt-409-dining-1024.jpg';
import rt409DiningFull from '../assets/reading-towers/generated/units/rt-409/rt-409-dining-2048.jpg';
import rt409Bathroom from '../assets/reading-towers/generated/units/rt-409/rt-409-bathroom-1024.jpg';
import rt409BathroomFull from '../assets/reading-towers/generated/units/rt-409/rt-409-bathroom-2048.jpg';

import rt418Living from '../assets/reading-towers/generated/units/rt-418/rt-418-living-1024.jpg';
import rt418LivingFull from '../assets/reading-towers/generated/units/rt-418/rt-418-living-2048.jpg';
import rt418Kitchen from '../assets/reading-towers/generated/units/rt-418/rt-418-kitchen-1024.jpg';
import rt418KitchenFull from '../assets/reading-towers/generated/units/rt-418/rt-418-kitchen-2048.jpg';
import rt418Bedroom from '../assets/reading-towers/generated/units/rt-418/rt-418-bedroom-1024.jpg';
import rt418BedroomFull from '../assets/reading-towers/generated/units/rt-418/rt-418-bedroom-2048.jpg';
import rt418Bathroom from '../assets/reading-towers/generated/units/rt-418/rt-418-bathroom-1024.jpg';
import rt418BathroomFull from '../assets/reading-towers/generated/units/rt-418/rt-418-bathroom-2048.jpg';

import lounge01 from '../assets/reading-towers/generated/lounge/lounge-01-1024.jpg';
import lounge01Full from '../assets/reading-towers/generated/lounge/lounge-01-2048.jpg';
import lounge02 from '../assets/reading-towers/generated/lounge/lounge-02-1024.jpg';
import lounge02Full from '../assets/reading-towers/generated/lounge/lounge-02-2048.jpg';
import lounge03 from '../assets/reading-towers/generated/lounge/lounge-03-1024.jpg';
import lounge03Full from '../assets/reading-towers/generated/lounge/lounge-03-2048.jpg';

import x10Living from '../assets/reading-towers/units/reference/rt-x10/x10-living-1536.jpg';
import x10Studio from '../assets/reading-towers/units/reference/rt-x10/x10-studio-1536.jpg';
import x10Bedroom from '../assets/reading-towers/units/reference/rt-x10/x10-bedroom-1536.jpg';
import x11Bedroom from '../assets/reading-towers/units/reference/rt-x11/x11-bedroom-1536.jpg';
import x11Living from '../assets/reading-towers/units/reference/rt-x11/x11-living-1536.jpg';
import x11BedroomAlt from '../assets/reading-towers/units/reference/rt-x11/x11-bedroom-alt-1536.jpg';
import x04BackBedroom from '../assets/reading-towers/units/reference/rt-x04/x04-back-bedroom-1536.jpg';
import x04Bedroom from '../assets/reading-towers/units/reference/rt-x04/x04-bedroom-1536.jpg';
import x04Kitchen from '../assets/reading-towers/units/reference/rt-x04/x04-kitchen-1536.jpg';
import x04LivingKitchen from '../assets/reading-towers/units/reference/rt-x04/x04-living-kitchen-1536.jpg';
import x17Bedroom from '../assets/reading-towers/units/reference/rt-x17/x17-bedroom-1536.jpg';
import x17BedroomAlt from '../assets/reading-towers/units/reference/rt-x17/x17-bedroom-alt-1536.jpg';
import x17Kitchen from '../assets/reading-towers/units/reference/rt-x17/x17-kitchen-1536.jpg';
import x17Living from '../assets/reading-towers/units/reference/rt-x17/x17-living-1536.jpg';
import x17SecondBedroom from '../assets/reading-towers/units/reference/rt-x17/x17-second-bedroom-1536.jpg';
import x19Bathroom from '../assets/reading-towers/units/reference/rt-x19/x19-bathroom-1536.jpg';
import x19Kitchen from '../assets/reading-towers/units/reference/rt-x19/x19-kitchen-1536.jpg';
import x19Living from '../assets/reading-towers/units/reference/rt-x19/x19-living-1536.jpg';
import x20Bathroom from '../assets/reading-towers/units/reference/rt-x20/x20-bathroom-1536.jpg';
import x20Kitchen from '../assets/reading-towers/units/reference/rt-x20/x20-kitchen-1536.jpg';
import x20Living from '../assets/reading-towers/units/reference/rt-x20/x20-living-1536.jpg';

const buildingImage = (src, src2x, alt, srcWidth, src2xWidth) =>
  makeImageAsset({ src, src2x, alt, srcWidth, src2xWidth });

const generatedImage = (src, src2x, alt) =>
  makeImageAsset({ src, src2x, alt, srcWidth: 1024, src2xWidth: 2048 });

const singleImage = (src, alt, srcWidth = 1536) =>
  makeImageAsset({ src, alt, srcWidth, src2xWidth: srcWidth });

const galleryImages = {
  buildingExterior4864: buildingImage(exterior4864, exterior4864Full, 'Reading Tower exterior at 601 Penn Street', 1400, 2800),
  buildingExterior4870: buildingImage(exterior4870, exterior4870Full, 'Reading Tower exterior view', 1400, 2800),
  buildingExterior4873: buildingImage(exterior4873, exterior4873Full, 'Reading Tower exterior from Penn Street', 1400, 2800),
  buildingExterior4876: buildingImage(exterior4876, exterior4876Full, 'Reading Tower exterior view', 1400, 2800),
  buildingExterior4890: buildingImage(exterior4890, exterior4890Full, 'Reading Tower exterior at 601 Penn Street', 1400, 2800),
  buildingFoyer: buildingImage(foyer, foyerFull, 'Reading Tower foyer', 1400, 2800),
  buildingHope: buildingImage(hope, hopeFull, 'Reading Tower common area', 1400, 2800),
  buildingNorthView: buildingImage(northView, northViewFull, 'View from Reading Tower', 1400, 2048),
  buildingSouthView: buildingImage(southView, southView, 'View from Reading Tower', 1400, 1400),
  rt404Living: generatedImage(rt404Living, rt404LivingFull, 'Reading Tower 2 bedroom unit living room'),
  rt404Kitchen: generatedImage(rt404Kitchen, rt404KitchenFull, 'Reading Tower 2 bedroom unit kitchen'),
  rt404Bedroom: generatedImage(rt404Bedroom, rt404BedroomFull, 'Reading Tower 2 bedroom unit bedroom'),
  rt404BedroomAlt: generatedImage(rt404BedroomAlt, rt404BedroomAltFull, 'Reading Tower 2 bedroom unit second bedroom'),
  rt418Living: generatedImage(rt418Living, rt418LivingFull, 'Reading Tower 1 bedroom unit living room'),
  rt418Kitchen: generatedImage(rt418Kitchen, rt418KitchenFull, 'Reading Tower 1 bedroom unit kitchen'),
  rt418Bedroom: generatedImage(rt418Bedroom, rt418BedroomFull, 'Reading Tower 1 bedroom unit bedroom'),
  rt418Bathroom: generatedImage(rt418Bathroom, rt418BathroomFull, 'Reading Tower 1 bedroom unit bathroom'),
  rt409Living: generatedImage(rt409Living, rt409LivingFull, 'Reading Tower studio unit living area'),
  rt409Kitchen: generatedImage(rt409Kitchen, rt409KitchenFull, 'Reading Tower studio unit kitchen'),
  rt409Dining: generatedImage(rt409Dining, rt409DiningFull, 'Reading Tower studio unit dining area'),
  rt409Bathroom: generatedImage(rt409Bathroom, rt409BathroomFull, 'Reading Tower studio unit bathroom'),
  lounge01: generatedImage(lounge01, lounge01Full, 'Reading Tower resident lounge'),
  lounge02: generatedImage(lounge02, lounge02Full, 'Reading Tower resident lounge seating'),
  lounge03: generatedImage(lounge03, lounge03Full, 'Reading Tower resident lounge view'),
  corner2Living: singleImage(x10Living, 'Reading Tower Corner 2 living room'),
  corner2Residence: singleImage(x10Studio, 'Reading Tower Corner 2 residence'),
  corner2Bedroom: singleImage(x10Bedroom, 'Reading Tower Corner 2 bedroom'),
  corner2BedroomView: singleImage(x11Bedroom, 'Reading Tower Corner 2 bedroom view'),
  corner2LivingAlt: singleImage(x11Living, 'Reading Tower Corner 2 living room'),
  corner2BedroomAlt: singleImage(x11BedroomAlt, 'Reading Tower Corner 2 bedroom'),
  x04BackBedroom: singleImage(x04BackBedroom, 'Reading Tower bedroom'),
  x04Bedroom: singleImage(x04Bedroom, 'Reading Tower bedroom'),
  x04Kitchen: singleImage(x04Kitchen, 'Reading Tower kitchen'),
  x04LivingKitchen: singleImage(x04LivingKitchen, 'Reading Tower living room and kitchen'),
  x17Bedroom: singleImage(x17Bedroom, 'Reading Tower bedroom'),
  x17BedroomAlt: singleImage(x17BedroomAlt, 'Reading Tower bedroom'),
  x17Kitchen: singleImage(x17Kitchen, 'Reading Tower kitchen'),
  x17Living: singleImage(x17Living, 'Reading Tower living room'),
  x17SecondBedroom: singleImage(x17SecondBedroom, 'Reading Tower bedroom'),
  x19Bathroom: singleImage(x19Bathroom, 'Reading Tower bathroom'),
  x19Kitchen: singleImage(x19Kitchen, 'Reading Tower kitchen'),
  x19Living: singleImage(x19Living, 'Reading Tower living room'),
  x20Bathroom: singleImage(x20Bathroom, 'Reading Tower bathroom'),
  x20Kitchen: singleImage(x20Kitchen, 'Reading Tower kitchen'),
  x20Living: singleImage(x20Living, 'Reading Tower living room'),
};

const galleryRows = [
  { type: 'double', images: [galleryImages.buildingExterior4864, galleryImages.buildingExterior4870] },
  { type: 'double', images: [galleryImages.x04LivingKitchen, galleryImages.buildingFoyer] },
  { type: 'single', images: [galleryImages.buildingExterior4873] },
  { type: 'double', images: [galleryImages.x17Living, galleryImages.x17Bedroom] },
  { type: 'double', images: [galleryImages.x17SecondBedroom, galleryImages.x17Kitchen] },
  { type: 'double', images: [galleryImages.x19Living, galleryImages.x19Kitchen] },
  { type: 'single', images: [galleryImages.x20Living] },
  { type: 'double', images: [galleryImages.x04Kitchen, galleryImages.x04Bedroom] },
  { type: 'double', images: [galleryImages.corner2Bedroom, galleryImages.corner2Residence] },
  { type: 'double', images: [galleryImages.corner2Living, galleryImages.x19Bathroom] },
  { type: 'single', images: [galleryImages.corner2LivingAlt] },
  { type: 'double', images: [galleryImages.corner2BedroomView, galleryImages.corner2BedroomAlt] },
  { type: 'double', images: [galleryImages.x20Kitchen, galleryImages.rt404Living] },
  { type: 'double', images: [galleryImages.rt404Kitchen, galleryImages.rt404Bedroom] },
  { type: 'double', images: [galleryImages.rt404BedroomAlt, galleryImages.rt418Living] },
  { type: 'double', images: [galleryImages.rt418Kitchen, galleryImages.rt418Bedroom] },
  { type: 'double', images: [galleryImages.rt418Bathroom, galleryImages.rt409Living] },
  { type: 'single', images: [galleryImages.rt409Kitchen] },
  { type: 'double', images: [galleryImages.rt409Dining, galleryImages.rt409Bathroom] },
  { type: 'double', images: [galleryImages.lounge02, galleryImages.lounge03] },
  { type: 'single', images: [galleryImages.lounge01] },
  { type: 'double', images: [galleryImages.buildingExterior4876, galleryImages.buildingExterior4890] },
  { type: 'double', images: [galleryImages.buildingNorthView, galleryImages.buildingHope] },
];

const GalleryImage = ({ item, className, sizes, onZoom }) => (
  <img
    src={item.src}
    srcSet={item.widthSrcSet}
    alt={item.alt}
    sizes={sizes}
    className={className}
    loading="lazy"
    decoding="async"
    onClick={() => onZoom(item.full)}
  />
);

const GalleryPage = () => {
  const primaryColor = 'text-teal-700';
  const [zoomSrc, setZoomSrc] = useState(null);
  const hero = galleryImages.buildingExterior4890;

  useEffect(() => {
    document.body.style.overflow = zoomSrc ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [zoomSrc]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setZoomSrc(null);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div className="bg-white">
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="space-y-4 text-center md:text-left">
            <p className={`text-sm font-semibold uppercase tracking-wider ${primaryColor}`}>GALLERY</p>
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-1400 leading-tight">The Reading Tower Lifestyle</h1>
            <p className="text-xl text-gray-700">Downtown Reading / City Views / Modern Residences</p>
            <p className="text-xl text-gray-700">Updated Interiors / Central Location / Everyday Convenience</p>
            <p className="text-sm italic text-gray-500 pt-4">
              Click any image below to view it fullscreen.
            </p>
          </div>
          <div className="w-full">
            <img
              src={hero.src}
              srcSet={hero.widthSrcSet}
              sizes="(min-width: 768px) 50vw, 100vw"
              alt={hero.alt}
              className="w-full h-auto md:h-[350px] lg:h-[450px] object-cover rounded-lg shadow-xl"
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-4 md:space-y-6">
          {galleryRows.map((row, idx) => (
            <div key={idx}>
              {row.type === 'single' && (
                <GalleryImage
                  item={row.images[0]}
                  sizes="100vw"
                  className="w-full h-auto md:h-[60vh] object-cover rounded-lg shadow-lg align-bottom cursor-zoom-in"
                  onZoom={setZoomSrc}
                />
              )}

              {row.type === 'double' && (
                <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
                  {row.images.map((item) => (
                    <div key={item.src} className="w-full sm:w-1/2">
                      <GalleryImage
                        item={item}
                        sizes="(min-width: 640px) 50vw, 100vw"
                        className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg cursor-zoom-in"
                        onZoom={setZoomSrc}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {zoomSrc && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={() => setZoomSrc(null)}
        >
          <div className="relative">
            <button
              onClick={(e) => { e.stopPropagation(); setZoomSrc(null); }}
              className="absolute top-2 right-2 w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 flex items-center justify-center bg-black bg-opacity-50 rounded-full text-white z-10"
              aria-label="Close zoom"
            >
              x
            </button>
            <img
              src={zoomSrc}
              alt="Zoomed"
              className="max-w-[90vw] max-h-[90vh] rounded-lg object-contain"
              loading="eager"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
